import React, { useContext } from "react";
import BaseLayout from "../components/global/BaseLayout";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";



export default function Products() {
    const { rpdata } = useContext(GlobalDataContext);

    return (
      <BaseLayout PageName="Products">
        <TransparentHeader
          headertitle={"Products"}
          Subheader={"Products"}
          bgimg={`${rpdata?.stock?.[5]}`}
        />

        <section className="h-screen w-full text-center flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center w-4/5 md:max-w-2xl">
            <h1>Our Products, Coming Soon!!</h1>

            <a
              href="https://aagranitecountertops.naturalstoneinventory.com/?OR=USA"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-500 text-white text-lg font-semibold py-3 px-6 rounded-full shadow-lg hover:bg-green-600 transition-colors"
            >
              Follow Link
            </a>
          </div>
        </section>
      </BaseLayout>
    );
}